import { render, staticRenderFns } from "./BtnGuardar.vue?vue&type=template&id=1b13c5b3&"
import script from "./BtnGuardar.vue?vue&type=script&lang=js&"
export * from "./BtnGuardar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports